import React from "react";
import { Button, Result, Typography } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

const { Paragraph, Text } = Typography;

const ErrorFallback = ({ error, resetErrorBoundary }) => {
  const { t } = useTranslation();

  return (
    <Result
      status={"error"}
      title={t("_components.error.index.title")}
      subTitle={t("_components.error.index.subTitle")}
      extra={
        <Button type="primary" onClick={resetErrorBoundary}>
          {t("_components.error.index.button")}
        </Button>
      }
    >
      <div className="desc">
        <Paragraph>
          <Text
            strong
            style={{
              fontSize: 16,
            }}
          >
            {t("_components.error.index.paragraph")}
          </Text>
        </Paragraph>
        <Paragraph>
          <CloseCircleOutlined style={{ color: "red" }} /> {error.message}
        </Paragraph>
      </div>
    </Result>
  );
};

export default ErrorFallback;
